import { createSlice } from "@reduxjs/toolkit";

const DEFALTE_STATE = {
  cotacoes: [],
  itensCotacao: [],
  cotacaoSelecionada: null,
  itemSelecionado: null,
};

const cotacaoSlice = createSlice({
  name: "cotacao",
  initialState: DEFALTE_STATE,
  reducers: {
    setCotacoes(state, action) {
      state.cotacoes = action.payload;
      return state;
    },
    setItensCotacao(state, action) {
      state.itensCotacao = action.payload;
      return state;
    },
    setCotacaoSelecionada(state, action) {
      state.cotacaoSelecionada = action.payload;
      return state;
    },
    setItemSelecionado(state, action) {
      state.itemSelecionado = action.payload;
      return state;
    },
    setCheckedItemCotacao(state, action) {
      const { itemId, add, remove } = action.payload;
      const itemIndex = state.itensCotacao.findIndex(
        (item) => item.id === itemId
      );
      if (itemIndex !== -1) {
        if (add)
          state.itensCotacao[itemIndex].quantidadeItens =
            state.itensCotacao[itemIndex].quantidadeItens > 0
              ? state.itensCotacao[itemIndex].quantidadeItens + 1
              : 1;
        if (remove && state.itensCotacao[itemIndex].quantidadeItens > 0)
          state.itensCotacao[itemIndex].quantidadeItens -= 1;
      }
      return state;
    },
    clearState() {
      return DEFALTE_STATE;
    },
  },
});

export const {
  setCotacoes,
  setItensCotacao,
  setCotacaoSelecionada,
  setItemSelecionado,
  setCheckedItemCotacao,
  clearState,
} = cotacaoSlice.actions;
export default cotacaoSlice.reducer;
